import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Link from "@material-ui/core/Link";

import "./Adatok.css";
import { ReactComponent as PottyIndikatorok } from "../../img/potty_indikatorok.svg";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  control: {
    padding: theme.spacing(2),
  },
});

class Adatok extends Component {
  constructor(props) {
    super(props);
    this.state = { expanded: "" };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(panelName) {
    const expanded = panelName === this.state.expanded ? "" : panelName;
    this.setState({ expanded });
  }
  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        {this.props.rigthMenu.map((menu, menuIndex) => {
          return (
            <React.Fragment key={"rightMenu-" + menu.name + "-" + menuIndex}>
              <Accordion
                expanded={this.state.expanded === "panel-" + menuIndex}
                onChange={() => this.handleChange("panel-" + menuIndex)}
                className="incdicatorList"
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={"panel" + menuIndex + "a-content"}
                  id={"panel" + menuIndex + "a-header"}
                >
                  <Typography className={"indocatorHeading " + classes.heading}>
                    {menu.name}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {menu.indicators.map((indicator, indicatorIndex) => {
                    return (
                      <React.Fragment
                        key={"indicatorKey-" + indicator + "-" + indicatorIndex}
                      >
                        <div
                          className={
                            "indicatorIcon" +
                            (this.props.active.menuIndex === menuIndex &&
                            this.props.active.indicatorIndex === indicatorIndex
                              ? " active"
                              : "")
                          }
                        >
                          <PottyIndikatorok />
                          <Link
                            href="#"
                            className="indicatorLink"
                            onClick={() =>
                              this.props.SetIndicator(menuIndex, indicatorIndex)
                            }
                          >
                            {indicator}
                          </Link>
                        </div>
                      </React.Fragment>
                    );
                  })}
                </AccordionDetails>
              </Accordion>
            </React.Fragment>
          );
        })}
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(Adatok);
